import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clearOnBackspace(event) {
    if (event.key !== "Backspace" || this.element.type !== "password") return
    event.preventDefault()
    this.element.value = ""
    this.element.type = "text"
  }

  maskOnBlur() {
    if (this.element.type === "text" && this.element.value) this.element.type = "password"
  }
}
